import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onEdit?: () => void
  onDelete?: () => void
  deleteDisabled?: boolean
}

export const Options = ({ onEdit, onDelete, deleteDisabled = false }: Props) => {
  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center">
        {onEdit && (
          <PopoverMenu.TouchableOption
            title={i18n.t('common.edit')}
            onClick={onEdit}
            icon="pencil"
          />
        )}
        {onDelete && (
          <PopoverMenu.TouchableOption
            title={i18n.t('common.delete')}
            onClick={onDelete}
            icon="delete"
            danger
            disabled={deleteDisabled}
          />
        )}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}
